module.exports = __webpack_public_path__ + "5c2f04c9e772f5291eb47170070d1fab.svg";